import theme from "./theme";


export const mobileScreen = theme.breakpoints.down('md')
export const mobileSmallScreen = theme.breakpoints.down('sm')